import { render, staticRenderFns } from "./CourseModules.vue?vue&type=template&id=389a6c08&scoped=true&"
import script from "./CourseModules.vue?vue&type=script&lang=ts&"
export * from "./CourseModules.vue?vue&type=script&lang=ts&"
import style0 from "./CourseModules.vue?vue&type=style&index=0&id=389a6c08&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "389a6c08",
  null
  
)

export default component.exports